export default {
  users: [],
  authenticated: false,
  user: null,
  userToken: null, // jwt
  userGuide: false,
  userProfile: null,
};
